export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/company_sku_identifiers/state.js